import { useAtom } from '@reatom/npm-react'
import React from 'react'

import { CurrencyModel } from '@root/entities/currency'
import { selectedNetworkAtom } from '@root/entities/network'
import { FilterTotal } from '@root/features/trade/filters'
import { type TradeTableColumnId } from '@root/features/trade/tables/trades-table/atoms/reatom-trades-table'

import type { TypeHelper } from '@blade/std-lib'
import type { Pair } from '@root/entities/pair'
import type { Transaction } from '@root/entities/transaction'
import type { ColumnHeaderProps } from '@root/shared/ui-kit'

export type TradeTotalHeaderProps = TypeHelper.OmitKey<
  ColumnHeaderProps<Transaction.Transaction, TradeTableColumnId>,
  't' | 'itemsStateAtom'
> & {
  currencyType: 'usd' | 'base'
  pair: Pair.PairMinimal | undefined
}

export const TradeTotalHeader: React.FC<TradeTotalHeaderProps> = ({
  filter,
  setColumnFilter,
  clearColumnFilter,
  columnId,
  currencyType,
  pair,
}) => {
  const [network] = useAtom(selectedNetworkAtom)
  return (
    <FilterTotal
      filter={filter}
      setColumnFilter={setColumnFilter}
      clearColumnFilter={clearColumnFilter}
      columnId={columnId}
      currencyType={currencyType}
      baseCurrency={pair?.base ?? CurrencyModel.nativeOf(network)}
    />
  )
}
